






import { Component, Vue } from 'vue-property-decorator';
import TermsModal from '@/components/TermsModal.vue';
import * as JwtUtil from '@/common/JwtUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

@Component({
  components: {
    'e-terms-modal': TermsModal,
  },
})
export default class App extends Vue {
  /* eslint-disable class-methods-use-this */
  created() {
    // メールアドレス変更メール送信時にセットしたログイン情報を復元
    const token = JwtUtil.getLocalJwt();
    if (token) {
      JwtUtil.setJwt(token);
      JwtUtil.deleteLocalJwt();
    }

    // 検定情報を取得しstoreに保存
    const ExamRepository = RepositoryFactory.get().exam;
    ExamRepository.getExam().then((response) => {
      if (response.status === 200) {
        this.$store.commit('saveExamInfo', response.data);
      }
    });
  }
}
